<style scoped> 
    .label {
        font-weight: 600;
    }
</style>
<template>
    <div class="form-group mb-4">
		<label class="label">{{ $t('Final destination') }}</label>
		<app-input 
            type="search-select" 
			v-model="selected" 
			:required="true" 
			:list="list" 
			:placeholder="$t('Select final destination.')"
            :disabled="read"
		/>
	</div>
</template>
  
<script>
    export default {
        name: 'FinalDestination',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
            read : {
                type : Boolean,
                default : false
            },
            list : {
                type : Array,
                default : [],
            }
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>